import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { Header } from "../styled";
import { List, Tile, Name, Description, ListWrapper, TileLink } from "./styled";
import { useTranslation } from "react-i18next";

const Offer = () => {
    const { t } = useTranslation();

    const items = t("offer.items", { returnObjects: true });

    return (
        <ListWrapper id="services">
            <StaggeredContainer>
                <StaggeredItem>
                    <Header>{t("offer.title")}</Header>
                </StaggeredItem>

                <StaggeredItem>
                    <List>
                        {items.map((item, index) => (
                            <Tile key={item.target}>
                                <TileLink
                                    to={item.target}
                                    smooth
                                    duration={600 + index * 200}
                                    offset={-90}
                                >
                                    <Name>{item.name}</Name>
                                    <Description>{item.description}</Description>
                                </TileLink>
                            </Tile>
                        ))}
                    </List>
                </StaggeredItem>
            </StaggeredContainer>
        </ListWrapper>
    );
};

export default Offer;